import { render, staticRenderFns } from "./MediakitProductsAvailabilityColumn.vue?vue&type=template&id=4d0223d0&"
import script from "./MediakitProductsAvailabilityColumn.vue?vue&type=script&lang=js&"
export * from "./MediakitProductsAvailabilityColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports